import Vue from 'vue'
import { HTTP } from '../../../../utils/httpCommonUtil'
import { BallPulseLoader } from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import { getRestParamErrorMessage, getRestResponseErrorMessage } from '@/utils/serverErrorMessageUtil';
import flatPickr from 'vue-flatpickr-component';
import { UserRoleEnum } from '@/enums/userRolesEnum'
import GenericModal from '@/componentsReusable/genericModal.vue'
import facilityEventHub from '@/components/facility/FacilityEventHub';
import MaskedInput from 'vue-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export default Vue.component('facility-specialty-rates-card', {
  name: 'FacilitySpecialtyRatesCard',
  data () {
    return {
      cardExpanded: false,
      loadingInitialData: false,
      savingNewFacilitySpecialtyRate: false,
      facilitySpecialtyRates: [] as any[],
      isAuthorizedToDelete: false,
      showConfirmationModal: false,
      showDeleteSpecialtyConfirmationModal: false,
      pendingDeleteFacilitySpecialtyRate: null,
      systemRateTypes: [],
      systemProviderLevels: [],
      feeMask: createNumberMask({
        prefix: '',
        allowDecimal: true,
        decimalLimit: 2,
        integerLimit: 4,
        thousandsSeparatorSymbol: ''
      }),
    }
  },
  components: {
    BallPulseLoader,
    VueSimpleSpinner,
    GenericModal,
    flatPickr,
    MaskedInput
  },
  beforeMount: function () {
    this.isAuthorizedToDelete = this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER]);
  },
  created: function () {
    facilityEventHub.$on('SPECIALTY_CHANGE', this.specialtyChangeEvent)
  },
  beforeDestroy: function () {
    facilityEventHub.$off('SPECIALTY_CHANGE', this.specialtyChangeEvent)
  },
  filters: {
    // currency (num: any) {
    //   if (num === null || num === undefined) {
    //     return '$0';
    //   } else {
    //     return '$' + Number.parseFloat(num).toFixed(2).toLocaleString();
    //   }
    // }
  },
  methods: {
    specialtyChangeEvent () {
      setTimeout( () => {
        this.getSystemProviderLevels();
        this.getSystemRateTypes();
        this.getFacilitySpecialtyRates();
      },0);
    },
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.getSystemProviderLevels();
        this.getSystemRateTypes();
        this.getFacilitySpecialtyRates();
      }
    },
    getSystemProviderLevels () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 500);
      HTTP.get('/api/provider_levels')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Provider Levels.");
        }
        self.systemProviderLevels = response.data.data;
      })
      .catch(function () {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving system Provider Levels.'
        });
      })
    },
    getSystemRateTypes () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 500);
      HTTP.get('/api/rate-types')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Rate Types.");
        }
        self.systemRateTypes = response.data.data;
      })
      .catch(function () {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving system Rate Types.'
        });
      })
    },
    getFacilitySpecialtyRates () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/facilities/' + this.$route.params.facilityId + '/specialties/' + this.$route.params.specialtyId + '/rates')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Provider Facility Specialty Rates.");
        }
        let freshFacilitySpecialtyRates = response.data.data;
        freshFacilitySpecialtyRates.forEach( function (facilitySpecialtyRate: any) {
          facilitySpecialtyRate.isEditing = false;
          facilitySpecialtyRate.isNew = false;
          facilitySpecialtyRate.updatingData = false;
          facilitySpecialtyRate.billRate = '' + facilitySpecialtyRate.billRate;
          facilitySpecialtyRate.payRate = '' + facilitySpecialtyRate.payRate;
          facilitySpecialtyRate.oldProviderLevelId = '' + facilitySpecialtyRate.providerLevelId;
          facilitySpecialtyRate.oldRateTypeId = '' + facilitySpecialtyRate.rateTypeId;
        });

        self.facilitySpecialtyRates = freshFacilitySpecialtyRates;
      })
      .catch(function (err) {
        console.log('response Error!');
        console.log(err);
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Facility Specialty Rates.'
        });
      })
    },
    facilitySpecialtyRateTypeChange (facilitySpecialtyRate: any) {
      this.systemRateTypes.forEach(function (rateType: any) {
        if (facilitySpecialtyRate.rateTypeId === rateType.id) {
          facilitySpecialtyRate.rateTypeName = rateType.name;
        }
      });
      // facilitySpecialtyRate.isAvailable = facilitySpecialtyRate.isAvailableString === 'true' ? true : false;
    },
    facilitySpecialtyProviderLevelChange (facilitySpecialtyRate: any) {
      this.systemProviderLevels.forEach(function (providerLevel: any) {
        if (facilitySpecialtyRate.providerLevelId === providerLevel.id) {
          facilitySpecialtyRate.providerLevelName = providerLevel.name;
        }
      });
      // facilitySpecialtyRate.isAvailable = facilitySpecialtyRate.isAvailableString === 'true' ? true : false;
    },
    saveFacilitySpecialtyRate (newFacilitySpecialtyRate: any) {
      let self = this
      self.savingNewFacilitySpecialtyRate = true;
      // newFacilitySpecialtyRate.isWelcomed = newFacilitySpecialtyRate.isWelcomed === 'true' ? true : false;
      HTTP.post('/api/facilities/' + newFacilitySpecialtyRate.facilityId + '/specialties/' + newFacilitySpecialtyRate.specialtyId + '/rates', newFacilitySpecialtyRate)
      .then(function (response) {
        self.savingNewFacilitySpecialtyRate = false;
        newFacilitySpecialtyRate.isEditing = false;
        self.getFacilitySpecialtyRates();
      })
      .catch(function (error) {
        self.savingNewFacilitySpecialtyRate = false;

        // newFacilitySpecialtyRate.idErrorMessage = getRestParamErrorMessage(error, 'id');
        newFacilitySpecialtyRate.providerLevelIdErrorMessage = getRestParamErrorMessage(error, 'providerLevelId');
        newFacilitySpecialtyRate.rateTypeIdErrorMessage = getRestParamErrorMessage(error, 'rateTypeId');
        newFacilitySpecialtyRate.billRateErrorMessage = getRestParamErrorMessage(error, 'billRate');
        newFacilitySpecialtyRate.payRateErrorMessage = getRestParamErrorMessage(error, 'payRate');

        if (
          !newFacilitySpecialtyRate.providerLevelIdErrorMessage.length &&
          !newFacilitySpecialtyRate.rateTypeIdErrorMessage.length &&
          !newFacilitySpecialtyRate.billRateErrorMessage.length &&
          !newFacilitySpecialtyRate.payRateErrorMessage.length
        ) {
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Saving',
            text: generalError ? generalError : 'An error occurred saving facilitySpecialtyRate.',
            // duration: 5000
          });
        }

      })
    },

    updateFacilitySpecialtyRate (updatedSpecialty: any) {
      let self = this
      updatedSpecialty.updatingData = true;
      HTTP.put('/api/facilities/' + updatedSpecialty.facilityId + '/specialties/' + updatedSpecialty.specialtyId + '/rates', updatedSpecialty)
      .then(function (response) {
        updatedSpecialty.updatingData = false;
        updatedSpecialty.isEditing = false;
        self.getFacilitySpecialtyRates();
        self.$notify({
          group: 'main',
          type: 'success',
          title: 'Successfully Updated',
          text: 'Successfully updated Facility Rate Specialty.',
          // duration: 5000
        });
      })
      .catch(function (error) {
        updatedSpecialty.updatingData = false;

        updatedSpecialty.providerLevelIdErrorMessage = getRestParamErrorMessage(error, 'providerLevelId');
        updatedSpecialty.rateTypeIdErrorMessage = getRestParamErrorMessage(error, 'rateTypeId');
        updatedSpecialty.billRateErrorMessage = getRestParamErrorMessage(error, 'billRate');
        updatedSpecialty.payRateErrorMessage = getRestParamErrorMessage(error, 'payRate');

        if (
          !updatedSpecialty.providerLevelIdErrorMessage.length &&
          !updatedSpecialty.rateTypeIdErrorMessage.length &&
          !updatedSpecialty.billRateErrorMessage.length &&
          !updatedSpecialty.payRateErrorMessage.length
        ) {
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Updating',
            text: generalError ? generalError : 'An error occurred updating facility specialty rate.',
            // duration: 5000
          });
        }

      })
    },
    deleteSpecialtyConfirmed (deleteRate: any) {
      this.showDeleteSpecialtyConfirmationModal = false;
      this.deleteFacilitySpecialtyRate((this as any).pendingDeleteSpecialty, true, (this as any).pendingFacilityRate);
    },
    deleteFacilitySpecialtyRate (deleteSpecialty: any, bypassDeleteConfirmation: boolean = false, facilityRate: any) {
      // To prevent a double submit
      if (deleteSpecialty.updatingData) { console.log("returning."); return ; }

      if (!bypassDeleteConfirmation) {
        // Show Delete Confirmation Modal
        this.showDeleteSpecialtyConfirmationModal = true;
        (this as any).pendingDeleteSpecialty = deleteSpecialty;
        (this as any).pendingFacilityRate = facilityRate;
        return;
      } else {
        (this as any).pendingDeleteSpecialty = null;
        (this as any).pendingFacilityRate = null;
      }

      let self = this
      deleteSpecialty.updatingData = true;
      HTTP.delete('/api/facilities/' + deleteSpecialty.facilityId + '/specialties/' + deleteSpecialty.specialtyId + '/provider-levels/' + deleteSpecialty.providerLevelId + '/rate-types/' + deleteSpecialty.rateTypeId )
      .then(function (response) {
        deleteSpecialty.updatingData = false;
        deleteSpecialty.isEditing = false;
        // deleteSpecialty.hasBeenDeleted = true;
        self.getFacilitySpecialtyRates();
        // Remove this specialty from the specialties list
        // self.removeSpecialtyFromFacilityRate(deleteSpecialty, facilityRate);
        self.$notify({
          group: 'main',
          type: 'success',
          title: 'Successfully Deleted',
          text: 'Successfully deleted Facility Rate Specialty.',
          // duration: 5000
        });
      })
      .catch(function (error) {
        console.log('error');
        console.log(error);
        deleteSpecialty.updatingData = false;
        let generalError = getRestResponseErrorMessage(error);
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Deleting',
          text: generalError ? generalError : 'An error occurred deleting facility rate specialty.',
          // duration: 5000
        });
      })
    },

    toggleEditFacilitySpecialtyRate (facilitySpecialtyRate: any) {
      let selectedFacilitySpecialtyRateId = facilitySpecialtyRate.id;
      // Collapse any editing facilitySpecialtyRates
      // Delete any existing "new" facilitySpecialtyRates
      let indexesToDelete: any = [];
      this.facilitySpecialtyRates.forEach(function (facilitySpecialtyRate, index) {
        if (facilitySpecialtyRate.isNew) {
          indexesToDelete.push(index);
        }
        if (selectedFacilitySpecialtyRateId !== facilitySpecialtyRate.id) {
          facilitySpecialtyRate.isEditing = false;
        }
      });
      let self = this;
      indexesToDelete.forEach(function (indx: number) {
        self.facilitySpecialtyRates.splice(indx,1);
      })
      facilitySpecialtyRate.isEditing = !facilitySpecialtyRate.isEditing;
    },
    addFacilitySpecialtyRate () {
      // Collapse any editing facilitySpecialtyRates
      // Delete any existing "new" facilitySpecialtyRates
      let indexesToDelete: any = [];
      this.facilitySpecialtyRates.forEach(function (facilitySpecialtyRate, index) {
        if (facilitySpecialtyRate.isNew) {
          indexesToDelete.push(index);
        }
        facilitySpecialtyRate.isEditing = false;
      });
      let self = this;
      indexesToDelete.forEach(function (indx: number) {
        self.facilitySpecialtyRates.splice(indx,1);
      })

      let newFacilitySpecialtyRate = {
        id: -1,
        facilityId: this.$route.params.facilityId,
        specialtyId: this.$route.params.specialtyId,
        providerLevelId: null,
        rateTypeId: null,
        billRate: null,
        payRate: null,
        isEditing: true,
        isNew: true,
        updatingData: false
      };

      this.facilitySpecialtyRates.unshift(newFacilitySpecialtyRate);
    },
    cancel (facilitySpecialtyRate: any) {
      facilitySpecialtyRate.isEditing = false;
      if (facilitySpecialtyRate.isNew) {
        // Allow the editing UI to collapse before removing it from the array.
        let self = this;
        setTimeout(function () {
          self.facilitySpecialtyRates.shift();
        }, 300);
      } else {
        this.getFacilitySpecialtyRates();
      }
    },
    hourlyBillRateChange (facilitySpecialtyRate: any) {
      if (!facilitySpecialtyRate.payRate) {
        facilitySpecialtyRate.payRate = !facilitySpecialtyRate.billRate ? '' : '' + ((facilitySpecialtyRate.billRate-5) * .7)
      }
    },
  }
})



// WEBPACK FOOTER //
// ./src/components/facility/cards/facilitySpecialtyRates/FacilitySpecialtyRatesCard.ts